import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetFraudLockedCardTransactionRequest,
  DefaultApiGetSuspiciousTransactionsRequest,
  DefaultApiSendTransactionAuthorizationRequestRequest,
} from '@src/api/generated/user-api'

export const getFraudLockedCardTransaction = async (
  instance: AxiosInstance,
  params: DefaultApiGetFraudLockedCardTransactionRequest
) => {
  return await userApiDefaultApiFactory(instance).getFraudLockedCardTransaction(
    params
  )
}

export const getSuspiciousTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetSuspiciousTransactionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getSuspiciousTransactions(
    params
  )
}

export const postTransactionAuthorizationRequest = async (
  instance: AxiosInstance,
  params: DefaultApiSendTransactionAuthorizationRequestRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).sendTransactionAuthorizationRequest(params)
}

// Do Not Remove this line ===@import api client===
